import SACFrontendService from "@/services/SACFrontendService";
import store from "@/store/store";
import TokenHelper from "@/utils/token-helper";
import Vue from "vue";
import Router from "vue-router";

// views
import Coaching from "./components/training/coaching/Coaching.vue";
import Curriculum from "./components/training/curriculum/index.vue";
import TopicExplorer from "./components/training/explorer/templates/TopicExplorer.vue";
import Lecture from "./components/training/lectures/Lecture.vue";
import LecturesCalendar from "./components/training/lectures/pages/calendar.vue";
import LecturesIndex from "./components/training/lectures/pages/index.vue";
import OfflineClassTournament from "./components/training/tournaments/OfflineClassTournament.vue";
import OfflineClassTournaments from "./components/training/tournaments/OfflineClassTournaments.vue";
import TournamentRoundPresentation from "./components/admins/tournaments/TournamentRoundPresentation.vue";
import AdminNews from "./views/Admins/AdminNews.vue";
import AdminNotifications from "./views/Admins/AdminNotifications.vue";
import AdminPermissions from "./views/Admins/AdminPermissions.vue";
import AdminTickets from "./views/Admins/AdminTickets.vue";
import AdminTournament from "./views/Admins/AdminTournament.vue";
import AdminTournaments from "./views/Admins/AdminTournaments.vue";
import AdminTournamentSimulation from "./views/Admins/AdminTournamentSimulation.vue";
import AivAi from "./views/AivAi";
import EventRegister from "./views/EventRegister.vue";
import Game from "./views/Game.vue";
import GameV2 from "./views/GameV2";
import HallOfFame from "./views/HallOfFame.vue";
import Home from "./views/Home.vue";
import Leaderboards from "./views/Leaderboards.vue";
import Lessons from "./views/Lessons.vue";
import LiveLessons from "./views/LiveLessons";
import LiveMatches from "./views/LiveMatches.vue";
import Lobby from "./views/Lobby.vue";
import Login from "./views/Login.vue";
import Profile from "./views/Profile.vue";
import PvAi from "./views/PvAi";
import PvAiLevel from "./views/PvAiLevel";
import PvP from "./views/PvP";
import Ratings from "./views/Ratings";
import Simul from "./views/Simul.vue";
import SimulCreateOrEdit from "./views/SimulCreateOrEdit.vue";
import SimulGames from "./views/SimulGames.vue";
import Simuls from "./views/Simuls.vue";
import TeacherHome from "./views/Teachers/TeacherHome.vue";
import TeacherLogin from "./views/Teachers/TeacherLogin.vue";
import TestPage from "./views/TestPage.vue";
import Tournament from "./views/Tournament.vue";
import TournamentLive from "./views/TournamentLive.vue";
import TournamentRound from "./views/TournamentRound.vue";
import Tournaments from "./views/Tournaments.vue";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/event/register",
      name: "eventRegister",
      component: EventRegister,
      meta: {
        skipAuth: true,
      },
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        skipAuth: true,
      },
    },
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
    },
    {
      path: "/lobby",
      name: "lobby",
      component: Lobby,
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ "./views/About"),
    },
    {
      path: "/games/:gameId",
      name: "game",
      component: Game,
    },
    {
      path: "/games/v2/:gameId",
      name: "gameV2",
      component: GameV2,
    },
    {
      path: "/aivai",
      name: "aiVsAi",
      component: AivAi,
    },
    {
      path: "/pvai",
      name: "pVAi",
      component: PvAi,
    },
    {
      path: "/pvai-level",
      name: "pVAiLevel",
      component: PvAiLevel,
    },
    {
      path: "/pvp",
      name: "pVp",
      component: PvP,
    },
    {
      path: "/live",
      name: "liveMatches",
      component: LiveMatches,
    },
    {
      path: "/simuls",
      name: "simuls",
      component: Simuls,
    },
    {
      path: "/simuls/new",
      name: "simulCreate",
      component: SimulCreateOrEdit,
    },
    {
      path: "/simuls/:simulId/edit",
      name: "simulEdit",
      component: SimulCreateOrEdit,
    },
    {
      path: "/simuls/:simulId",
      name: "simul",
      component: Simul,
    },
    {
      path: "/simuls/:simulId/games",
      name: "simulGames",
      component: SimulGames,
    },
    {
      path: "/tournaments",
      name: "tournaments",
      component: Tournaments,
    },
    {
      path: "/tournaments/:tournamentId",
      name: "tournament",
      component: Tournament,
    },
    {
      path: "/tournaments/:tournamentId/games/:gameId",
      name: "tournamentGame",
      component: Game,
    },
    {
      path: "/tournaments/:tournamentId/games/v2/:gameId",
      name: "tournamentGameV2",
      component: GameV2,
    },
    {
      path: "/tournaments/:tournamentId/live",
      name: "tournamentLive",
      component: TournamentLive,
    },
    {
      path: "/tournaments/:tournamentId/rounds/:roundNumber",
      name: "tournamentRound",
      component: TournamentRound,
    },
    {
      path: "/hall-of-fame",
      name: "HallOfFame",
      component: HallOfFame,
    },

    {
      path: "/leaderboards",
      name: "Leaderboards",
      component: Leaderboards,
    },

    {
      path: "/ratings",
      name: "Ratings",
      component: Ratings,
    },

    {
      path: "/lessons",
      name: "Lessons",
      component: Lessons,
    },

    {
      path: "/live-lessons",
      name: "LiveLessons",
      component: LiveLessons,
    },

    {
      path: "/admin/tournaments",
      name: "AdminTournaments",
      component: AdminTournaments,
    },

    {
      path: "/admin/tournaments/:tournamentId",
      name: "AdminTournament",
      component: AdminTournament,
    },

    {
      path: "/admin/tournament/simulation",
      name: "AdminTournamentSimulation",
      component: AdminTournamentSimulation,
    },

    {
      path: "/admin/tickets",
      name: "AdminTickets",
      component: AdminTickets,
    },

    {
      path: "/admin/news",
      name: "AdminNews",
      component: AdminNews,
    },

    {
      path: "/admin/notifications",
      name: "AdminNotifications",
      component: AdminNotifications,
    },

    {
      path: "/admin/permissions",
      name: "AdminPermissions",
      component: AdminPermissions,
    },

    {
      path: "/topics",
      name: "Topics",
      component: TopicExplorer,
      // meta: {
      //   teacher: true,
      //   student: true,
      // },
    },
    {
      path: "/topics/:topicId",
      name: "Topic",
      component: () =>
        import("./components/training/explorer/templates/TopicPage.vue"),
      // meta: {
      //   teacher: true,
      // },
    },
    {
      path: "/examples",
      name: "Examples",
      component: Coaching,
      // meta: {
      //   teacher: true,
      //   student: true,
      // },
    },

    {
      path: "/admin/curriculum",
      name: "AdminCurriculum",
      component: Curriculum,
      // meta: {
      //   teacher: true,
      //   student: true,
      // },
    },

    {
      path: "/lectures",
      name: "LecturesIndex",
      component: LecturesIndex,
      // meta: {
      //   teacher: true,
      //   student: true,
      // },
    },
    {
      path: "/lectures/:lectureId",
      name: "lectures",
      component: Lecture,
      // meta: {
      //   teacher: true,
      //   student: true,
      // },
      props: true,
    },

    {
      path: "/teacher/login",
      name: "TeacherLogin",
      component: TeacherLogin,
      meta: {
        skipAuth: true,
        student: false,
        teacher: true,
      },
    },

    {
      path: "/teacher",
      redirect: "/teacher/home",
    },

    {
      path: "/teacher/home",
      name: "TeacherHome",
      component: TeacherHome,
      meta: {
        student: false,
        teacher: true,
      },
    },

    {
      path: "/teacher/class-tournaments",
      name: "OfflineClassTournaments",
      component: OfflineClassTournaments,
      meta: {
        student: false,
        teacher: true,
      },
    },

    {
      path: "/teacher/class-tournaments/:id",
      name: "OfflineClassTournament",
      component: OfflineClassTournament,
      meta: {
        student: false,
        teacher: true,
      },
    },

    {
      path: "/teacher/class-tournaments/:id/presentation",
      name: "TournamentRoundPresentation",
      component: TournamentRoundPresentation,
      meta: {
        student: false,
        teacher: true,
      },
    },

    {
      path: "/teacher/topics",
      name: "TeacherTopics",
      component: TopicExplorer,
      meta: {
        teacher: true,
        student: false,
      },
    },
    {
      path: "/teacher/topics/:topicId",
      name: "TeacherTopic",
      component: () =>
        import("./components/training/explorer/templates/TopicPage.vue"),
      meta: {
        teacher: true,
        student: false,
      },
    },
    {
      path: "/teacher/examples",
      name: "TeacherExamples",
      component: Coaching,
      meta: {
        teacher: true,
        student: false,
      },
    },

    {
      path: "/teacher/curriculum",
      name: "TeacherCurriculum",
      component: Curriculum,
      meta: {
        teacher: true,
        student: false,
      },
    },

    {
      path: "/teacher/lectures",
      name: "TeacherLecturesIndex",
      component: LecturesIndex,
      meta: {
        teacher: true,
        student: false,
      },
    },
    {
      path: "/teacher/lectures/calendar",
      name: "TeacherLecturesCalendar",
      component: LecturesCalendar,
      meta: {
        teacher: true,
        student: false,
      },
    },
    {
      path: "/teacher/lectures/:lectureId",
      name: "TeacherLecture",
      component: Lecture,
      meta: {
        teacher: true,
        student: false,
      },
      props: true,
    },

    {
      path: "/teacher/lessons",
      name: "TeacherLessons",
      component: Lessons,
      meta: {
        teacher: true,
        student: false,
      },
    },

    {
      path: "/teacher/liveLessons",
      name: "TeacherLiveLessons",
      component: LiveLessons,
      meta: {
        teacher: true,
        student: false,
      },
    },

    {
      path: "/test",
      name: "test",
      component: TestPage,
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  const skipAuth = to.meta?.skipAuth ?? false;

  if (skipAuth) {
    next();
    return;
  }

  const isTeacher = to.meta?.teacher ?? false;

  if (isTeacher) {
    const isAuthenticated = SACFrontendService.isAuthenticated();
    if (!isAuthenticated) {
      next({
        name: "TeacherLogin",
      });
      return;
    }

    next();
    return;
  }

  // update accessToken from route
  if (
    updateSessionFromQuery(to, "token", "accessToken") ||
    !store.getters.getUserId
  ) {
    // save userId from accessToken
    let userId = await TokenHelper.getPayloadField("id");
    if (userId) {
      localStorage.setItem("userId", userId);
      store.dispatch("queryProfileAction");
    }
  }

  // login route
  if (to.name === "login" && from.name !== "login") {
    next();
    return;
  }

  const tokenExpired = await TokenHelper.checkExpiry(null, to.fullPath);
  if (tokenExpired) {
    // Token is expired and auto sign-in failed, redirect to login
    next({
      name: "login",
      query: { redirect: to.fullPath },
    });
    return;
  }

  // Token is valid (either was already valid or auto sign-in succeeded)
  // Handle special case where user is going to login page but is already authenticated
  if (to.name === "login" && !tokenExpired) {
    next({ name: "home" });
    return;
  }

  next();
});

router.afterEach((to) => {
  let query = Object.assign({}, to.query);
  if (query.token) {
    delete query.token;
    router.replace({ query });
  }
  document.title = "Chess Squad Academy";
});

const updateSessionFromQuery = (route, queryKey, sessionKey) => {
  if (sessionKey == null) sessionKey = queryKey;
  let value = route.query[queryKey];
  if (!value) return null;

  localStorage.setItem(sessionKey, value);
  return value;
};

export default router;
